import { render, staticRenderFns } from "./BusinessNature.vue?vue&type=template&id=67eace80"
import script from "./BusinessNature.vue?vue&type=script&lang=js"
export * from "./BusinessNature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67eace80')) {
      api.createRecord('67eace80', component.options)
    } else {
      api.reload('67eace80', component.options)
    }
    module.hot.accept("./BusinessNature.vue?vue&type=template&id=67eace80", function () {
      api.rerender('67eace80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/profile/BusinessNature.vue"
export default component.exports